import script from "./PromoEdumotionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PromoEdumotionModal.vue?vue&type=script&setup=true&lang=js"

import "./PromoEdumotionModal.vue?vue&type=style&index=0&id=414f2d19&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-414f2d19"]])

export default __exports__